import Footer from '../Footer';
import './Contact.css'
import React from "react";


const Contact = () => {
    return       <div className="contact shadow-lg  p-2 mb-2 bg rounded">
    <h1 id="Contact">Contact Me</h1>
    <p>
        <a href="https://www.linkedin.com/in/kevin-giron-869598202/ ">Linkedin</a>
        <a href="mailto:kg19882020@gmail.com ">Email Me</a>
        <a href="https://github.com/SIN88">Github</a>
        <a href="https://docs.google.com/document/d/1ZiiF6Km2QSeGXlfyquxQZxPj-fUiMzGQsHq6b9zvtJE/edit?usp=sharing">Resume</a>

      </p>
    
   <Footer/>
   
      
  </div>
 
  

  
 
} 

export default Contact;